/* lua.js generated code 0.3.0 */
let HomeSceneBtn = require("clover/scene/component/homescene/HomeSceneButton")
let Button = xClass("ActivitiesButton", cc.Node)

Button.prototype.ctor = function (btnLayer) {
    let self = this
    cc.Node.prototype.ctor.call(self)
    self.btnLayer = btnLayer
    self.btns = table()
    self.init()
}
Button.prototype.init = function () {
    let self = this
    // self.imageNode.setPositionY(-5)
    // self.text.setPositionY(-60)
    // self.node = cc.CSLoader.createNode("cocos/activities_button_icon_anim.csb")
    // self.addChild(self.node)
    // self.node.setPositionX(40)
    // self.setPositionX(50)
    // self.setScale(-0.95, 0.95)
    self.setContentSize(120, 120)
    UIButton.create(self, true)
    PushBounceAnim.create(self)
    self.on(UIButtonEvent.Click, function () {
        self.onClick()
    })

    // let action = cc.CSLoader.createTimeline("cocos/activities_button_icon_anim.csb")
    // action.gotoFrameAndPlay(0, true)
    // self.node.runAction(action)

    // let lightNode = cc.CSLoader.createNode("cocos/activities_button_star_ready.csb")
    // self.node.addChild(lightNode)

    // let lightAnim = cc.CSLoader.createTimeline("cocos/activities_button_star_ready.csb")
    // lightAnim.gotoFrameAndPlay(0, true)
    // lightNode.runAction(lightAnim)
    
    let bg = cc.Sprite.createWithSpriteFrameName("homeScene/icon_bg.png")
    self.addChild(bg, -1, "bg")
    let icon = cc.Sprite.createWithSpriteFrameName("homeScene/activity_icon.png")
    icon.setScale(0.9)
    self.addChild(icon, 0, "icon")

    let text = cc.LabelTTF.create('活动', FONT_DEF.microsoftYahei_24_blueStroke)
    text.setPosition(0, -45)
    self.addChild(text)

    // self.redDot = cc.Sprite.createWithSpriteFrameName("h5library/reddot.png")
    self.redDot = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png")
    self.redDot.setScale(0.7)
    // self.redDot.setScale(1.2)
    self.redDot.setPosition(31,44)
    self.redDot.setVisible(false)
    self.addChild(self.redDot)
    // self.redDot.setVisible(self.show)
}
Button.prototype.addBtn = function (btn, index) {
    let self = this
    if (index == undefined) {
        index = 9999
    }
    btn.panelIndex = index
    table.insert(self.btns, btn)

    // 排序
    table.sort(self.btns, function (a, b) {
        return a.panelIndex > b.panelIndex
    })

    btn.setOnRedDotChange(function(show) {
        self.onSubBtnRedDotChange(show)
    })
}
Button.prototype.onSubBtnRedDotChange = function (show) {
    let self = this
    self.show = show
    if (!self.redDot) {
        return
    }
    if (show) {
        self.redDot.setVisible(true)
    } else {
        // 遍历检查是否有红点
        let count = $len(self.btns)
        for (let i = 1; i <= count; i += 1) {
            let btn = self.btns[i]
            if (btn.activitiesButtonRedDot) {
                self.redDot.setVisible(true)
                return
            }
        }

        // 如果所有子按钮都没有红点，把总按钮的红点去掉
        self.redDot.setVisible(false)
    }
}
Button.prototype.removeBtn = function (btn) {
    let self = this
    table.removebyvalue(self.btns, btn)
    
    if (self.btnLayer.activitiesButtonPanel) {
        self.btnLayer.activitiesButtonPanel.removeBtn(btn)
        // 如果板子开着，删除板子上的按钮
        // ...
    }
}
Button.prototype.onClick = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true

    function openPanel(panel) {
        let position = self.convertToWorldSpace()
        // position.x += self.getContentSize().width / 2 - 55
        position.x += self.getContentSize().width / 2 - 115
        position.y += 40
        panel.setPosition(position)
        panel.setAnchorPoint(0, 1)
        panel.open(self.btns)
        self.isBusy = false
    }
    
    if (!self.btnLayer.activitiesButtonPanel) {
        let panel = require("clover/scene/component/homescene/ActivitiesButtonsPanel").asyncCreate(function(panel) {

            self.btnLayer.activitiesButtonPanel = panel
            self.btnLayer.addChild(panel)
            openPanel(panel)
        }, function() {
            Toast.make("网络有点问题~刷新再试试~", null, function() {
                self.isBusy = false
            })
        }, function() {
            self.isBusy = false
        })
    } else {
        let panel = self.btnLayer.activitiesButtonPanel
        if (panel.isOpen) {
            panel.close()
            cc.log("close panel")
            self.isBusy = false
        } else {
            openPanel(panel)
        }
    }

}
module.exports = Button
